import { ReturnBaseUrl } from '@/network/request'
import { usergetStorageSync, usersetStorageSync } from '@/common/browser-storage.js'

/**
 * 服务端兼容级别只在登录成功时协商，业务页面禁止发请求探测版本。
 *
 * 缓存值约定：
 * - 不存在：新版 APP 安装/升级后尚未重新登录；
 * - 字符串 "0"：已经通过新版登录流程，但服务端没有 apiLevel；
 * - 字符串 "1" 及以上：服务端支持对应兼容级别。
 *
 * CACHE_SCHEMA 只在缓存语义发生重大变化时升级。普通页面功能、接口新增字段、
 * 性能优化和缺陷修复不得修改它或 CURRENT_REQUIRED_LEVEL。
 */
const CACHE_SCHEMA = 'v1'
const STORAGE_KEY_PREFIX = 'serverApiLevel:' + CACHE_SCHEMA + ':'
export const CURRENT_REQUIRED_LEVEL = 1

const promptedKeys = {}

function getServerAddress(vm) {
  return ReturnBaseUrl()
}

function getStorageKey(vm) {
  return STORAGE_KEY_PREFIX + encodeURIComponent(getServerAddress(vm))
}

function normalizeLevel(value) {
  const level = Number(value)
  return Number.isFinite(level) && level > 0 ? Math.floor(level) : 0
}

export function recordLoginServerApiLevel(vm, loginData) {
  const level = normalizeLevel(loginData && loginData.apiLevel)
  // 必须保存字符串；现有 usergetStorageSync 会忽略数字 0。
  usersetStorageSync(getStorageKey(vm), String(level))
  return level
}

export function getServerApiLevelState(vm) {
  const cachedValue = usergetStorageSync(getStorageKey(vm))
  if (cachedValue === undefined || cachedValue === null || cachedValue === '') {
    return {
      status: 'unconfirmed',
      level: 0,
      useModernRegion: false,
      useModernFollowManagement: false
    }
  }
  const parsedLevel = Number(cachedValue)
  if (!Number.isFinite(parsedLevel) || parsedLevel < 0) {
    return {
      status: 'unconfirmed',
      level: 0,
      useModernRegion: false,
      useModernFollowManagement: false
    }
  }
  const level = Math.floor(parsedLevel)
  return {
    status: level >= CURRENT_REQUIRED_LEVEL ? 'modern' : 'legacy',
    level: level,
    useModernRegion: level >= CURRENT_REQUIRED_LEVEL,
    // Level 1 尚未发布，区域导航和常用候选分页作为同一原子能力协商。
    useModernFollowManagement: level >= CURRENT_REQUIRED_LEVEL
  }
}

/**
 * 兼容提示只在当前 APP 进程内显示一次，不额外写入永久业务状态。
 */
export function shouldShowCompatibilityPrompt(vm, status) {
  const key = getStorageKey(vm) + ':' + status
  if (promptedKeys[key]) return false
  promptedKeys[key] = true
  return true
}
